const View = require('public_framework/view')
const Autocomplete = require('yet-another-autocomplete').default
const {debounce} = require('underscore')
const $ = require('jquery')

const MIN_QUERY_SIZE = 3
const DEBOUNCE_WAIT = 300

/**
 * A simple autocomplete, which uses remote endpoint for suggestion
 * Expects `data-remote-url` provided on the input component.
 * @see app/inputs/remote_autocomplete_input.rb
*/

module.exports = class RemoteAutocompleteView extends View {
  constructor () {
    super(...arguments)
    this.input = this.el.querySelector('input[type="text"]')
    this.hiddenField = this.el.querySelector('input[type="hidden"]')
    this.remoteURL = this.input.dataset.remoteUrl
    this.allowEmptyTerm = this.input.dataset.allowEmptyTerm || false
    this.model = this.input.dataset.model
    this.params = JSON.parse(this.input.dataset.includeRemoteParams || '{}')
    this.spinner().hide()
    this.cache = {}
    this.autocomplete = new Autocomplete(this.input, {
      query: debounce(this.onQuery.bind(this), DEBOUNCE_WAIT, true),
      onSelect: this.onSelect.bind(this),
      disableCaching: true
    })
    this.autocomplete.container.classList.add('autocomplete_v2')
    this.autocomplete.container.classList.remove('autocomplete_box')

    this.input.addEventListener('blur', () => {
      this.input.classList.remove('no-bottom-left-radius')
    })
  }

  get els () {
    return {
      spinner: '@spinner'
    }
  }

  onQuery (term, setSuggestions) {
    if (term.length < MIN_QUERY_SIZE) {
      if (!this.allowEmptyTerm) {
        setSuggestions([])
        this.input.classList.remove('no-bottom-left-radius')
        return
      } else term = ''
    }

    this.startSpinner()
    this.queryRemoteEndpoint(term)
      .done(results => {
        setSuggestions(results)
        if (results.length !== 0) {
          this.input.classList.add('no-bottom-left-radius')
        } else {
          this.input.classList.remove('no-bottom-left-radius')
        }
      })
      .fail(() => {
        setSuggestions([])
        this.input.classList.remove('no-bottom-left-radius')
      })
      .always(() => {
        this.stopSpinner()
      })
  }

  queryRemoteEndpoint (term) {
    const dfd = $.Deferred()

    const formParams = Object.keys(this.params).reduce((params, param) => {
      params[this.params[param]] = this.getFieldValue(param)
      return params
    }, {})

    const urlParams = this.encodeURL({model: this.model, term: term, ...formParams})
    const url = `${this.remoteURL}?${urlParams}`
    if (this.cache[url]) {
      dfd.resolve(this.cache[url])
    } else {
      $.get(url)
        .done(results => {
          this.cache[url] = results
          dfd.resolve(results)
        })
        .fail(dfd.reject)
    }

    return dfd.promise()
  }

  encodeURL (data) {
    return Object.keys(data).map(key => [key, data[key]].map(encodeURIComponent).join('=')).join('&')
  }

  getFieldValue (param) {
    return $(`input[name="${param}"]`).val()
  }

  startSpinner () {
    this.spinner().show()
  }

  stopSpinner () {
    this.spinner().hide()
  }

  onSelect (option) {
    this.input.value = option.text
    const value = this.input.dataset.valueType === 'text' ? option.text : option.value

    $(this.input).trigger('keywords_selected', {value})
    this.hiddenField.value = value
    this.input.classList.remove('no-bottom-left-radius')
  }

  unload () {
    this.autocomplete.destroy()
    this.input.classList.remove('no-bottom-left-radius')
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/ui/autocomplete/views/remote_autocomplete.js